module.exports = __webpack_public_path__ + "img/20200407153225776.bdf322a1.png";